import { UserTypes } from '@site-mate/dashpivot-shared-library';

export const ToastMessages = {
  [UserTypes.Contributor]: {
    invite: 'contributorAdded',
    update: 'contributorPermissionUpdated',
    remove: 'contributorRemoved',
  },
  [UserTypes.Visitor]: {
    invite: 'visitorAdded',
    update: 'visitorPermissionUpdated',
    remove: 'visitorRemoved',
  },
};

export const UserEventContexts = {
  [UserTypes.Contributor]: 'Dashpivot Contributor',
  [UserTypes.Visitor]: 'Dashpivot Visitor',
};

export const LearnMoreLinks = {
  [UserTypes.Contributor]: 'https://intercom.help/dashpivot/en/articles/6761343-dashpivot-contributors',
  [UserTypes.Visitor]: 'https://intercom.help/dashpivot/en/articles/6761341-dashpivot-visitors',
};
